import React, {useState, useRef, useEffect, useContext} from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import Advanced from './components/Advanced.jsx';
import useEventFeedSearch from "./useEventFeedSearch.js";

const AppContext = React.createContext({})

function EventFeedItems(props) {
    const dataContainer = useRef(null);
    const { perPage } = useContext(AppContext)

    useEffect(() => {
        if (dataContainer.current && props.data.length > perPage) {
            const lastItem = dataContainer.current.lastElementChild;
            lastItem.scrollIntoView({behavior: "smooth", block: "nearest"});
        }
    }, [props.data]);

    return (<div>
        {props.data.length > 0 ?
            <ul ref={dataContainer} className="list-group list-group-dividered list-group-full mb-1"> {props.data.map((item, index) => (
                <li key={`${item.event_feed_type}-${item.key}-${item.id}-${index}`} className="list-group-item">
                    <Advanced item={item} showProfilePics={props.showProfilePics} />
                </li>))}
            </ul>
            : <div></div>
        } </div>);
}

function EventFeedSearch(props) {
    const [query, setQuery] = useState('')
    const perPage = 15;
    const {
        loadedData, 
        totalCount, 
        loading, 
        filters, 
        search,
        getMoreResults} = useEventFeedSearch(props, query)

    const handleScroll = (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop - 1 <= e.target.clientHeight;
        if (bottom && !loading) getMoreResults();
    }

    const contextValue = { componentType: props.componentType, perPage: perPage };

    const {available_filters = []} = props.selectedFilters;

    return (<AppContext.Provider value={contextValue}>
        <Scrollbars className={contextValue.componentType + '-component'} style={{ ...props.style }} onScroll={handleScroll}>
            <div className="d-flex flex-row mb-1 p-1 bg-white input-group">
                <input
                    className="form-control rounded-0 border-0"
                    style={{zIndex: 'auto'}}
                    placeholder={I18n.t('search')}
                    value={query}
                    onKeyPress={(e) => {(e.key === 'Enter' ? search() : null)}}
                    onChange={(e) => setQuery(e.target.value)}
                />
                <button className="btn btn-primary rounded-0 flex-shrink-0 ml-1" onClick={() => search()}>{I18n.t('search')}</button>
            </div>

            {available_filters.length > 1 &&
                <div className="p-1 w-100">
                  <div className="btn-group">
                    {
                      available_filters.map((type) => {
                        return <button
                          key={`btn-${type}`}
                          onClick={() => search(type)}
                          className={'btn btn-' + (filters[type] ? type : '')}
                        >
                          { I18n.t(type == 'support' ? type : `${type}s`) }
                        </button>
                      })
                    }
                  </div>
                  <div className="btn-group">
                    <button onClick={() => search('all')} className={'btn btn-' + (filters['all'] ? 'all' : '')}>{I18n.t('all')}</button>
                  </div>
                </div>
            }

            {props.children}

            {(totalCount > loadedData.length) && <div className="text-center">
                <button type="button" className="btn btn-link" onClick={(e) => getMoreResults()}>{I18n.t(loading ? 'loading' : 'load_more')}</button>
            </div>}
        </Scrollbars>
    </AppContext.Provider>);
}

const EventFeeds = (props) => {
    const [data, setData] = useState([]);

    const updateEventFeed = (data) => {
        setData(data)
    }

    return (<EventFeedSearch updateEventFeed={updateEventFeed} componentType={'advanced'} { ...props }>
        <EventFeedItems data={data} showProfilePics={props.showProfilePics}></EventFeedItems>
    </EventFeedSearch>);
}
export default EventFeeds;
